export default __webpack_public_path__ + "ff414085d81e05c47b6732146a4cb18d.png";